/**
 * Get There call options (CONTACTS-SUBCONTRACT-LAYER.md Prompt E).
 *
 * "Call site" dials the RESOLVED on-site contact from the contact-card
 * endpoint — the same person the Contacts card shows and On My Way texts.
 * The legacy numbers (WO-briefing site contact, site phone, customer phone)
 * stay as additional options when they genuinely differ (deduped on digits),
 * per the TECH-JOB-SCREEN spec decision to offer both when they differ —
 * and as the whole list when the card hasn't resolved (offline, no contact).
 */
import type { RailCallOption } from "./workflow-rail";

export interface CallOptionInputs {
    /** Phone of the resolved on-site contact (contact-card endpoint). */
    resolvedOnSitePhone: string | null;
    /** WO briefing's extracted site contact phone. */
    briefingSiteContactPhone: string | null;
    /** Legacy jobs header: named site contact phone (sites default). */
    jobSiteContactPhone: string | null;
    /** Legacy jobs header: raw site line. */
    sitePhone: string | null;
    /** Legacy jobs header: job contact phone || customer phone. */
    customerPhone: string | null;
}

export function buildCallOptions(i: CallOptionInputs): RailCallOption[] {
    const options: RailCallOption[] = [];
    const seen = new Set<string>();
    const add = (label: string, phone: string | null | undefined) => {
        if (!phone) return;
        const key = phone.replace(/\D/g, "");
        if (!key || seen.has(key)) return;
        seen.add(key);
        options.push({ label, phone });
    };

    // The resolved on-site contact owns the "Call site" label.
    add("Call site", i.resolvedOnSitePhone);
    add("Call site contact", i.briefingSiteContactPhone);
    // Legacy site number: keep its historical label, but never render a
    // second button that also says "Call site" when the resolved contact
    // already took that name.
    add(
        i.jobSiteContactPhone ? "Call on-site contact" : i.resolvedOnSitePhone ? "Call site line" : "Call site",
        i.jobSiteContactPhone || i.sitePhone,
    );
    add("Call customer", i.customerPhone);
    return options;
}
